"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectProductComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _numeral = _interopRequireDefault(require("numeral"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _useMarketplace2 = _interopRequireDefault(require("../../hooks/useMarketplace"));

var _useGift2 = require("../../hooks/useGift");

var _SelectProductFooter = _interopRequireDefault(require("./SelectProductFooter"));

var _SelectProductNotice = _interopRequireDefault(require("./SelectProductNotice"));

var _SelectProductItems = _interopRequireDefault(require("./SelectProductItems"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    header: {
      padding: theme.spacing(3),
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(6)
    },
    root: {
      padding: theme.spacing(3)
    }
  };
});

var SelectProductComponent = function SelectProductComponent(_ref) {
  var onPreview = _ref.onPreview,
      showMarketplace = _ref.showMarketplace;
  var classes = useStyles();

  var _useGift = (0, _useGift2.useGift)(),
      giftId = _useGift.id,
      proposedProducts = _useGift.proposedProducts,
      recipient = _useGift.recipient;

  var _useMarketplace = (0, _useMarketplace2.default)(giftId),
      initialLoadProduct = _useMarketplace.initialLoadProduct,
      pagination = _useMarketplace.pagination;

  var recipientName = R.propOr('', 'first_name', recipient);
  var totalProducts = (0, _numeral.default)(pagination.total).format('0,0');
  (0, _react.useEffect)(function () {
    initialLoadProduct();
  }, [initialLoadProduct]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, "Choose one of these options that ", recipientName, " will love!")), proposedProducts.length > 0 && /*#__PURE__*/_react.default.createElement(_SelectProductNotice.default, {
    recipientName: recipientName
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    "data-testid": "CommonMarketplace-SelectProduct-ProposedList",
    container: true,
    direction: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_SelectProductItems.default, {
    recipientName: recipientName,
    onPreview: onPreview
  })), /*#__PURE__*/_react.default.createElement(_SelectProductFooter.default, {
    totalProducts: totalProducts,
    onGotoMarketplace: showMarketplace,
    recipientName: recipientName
  }));
};

exports.SelectProductComponent = SelectProductComponent;
SelectProductComponent.propTypes = {
  onPreview: _propTypes.default.func.isRequired,
  showMarketplace: _propTypes.default.func.isRequired
};
var _default = SelectProductComponent;
exports.default = _default;